import React from 'react';
import { Outlet } from 'react-router-dom';

type RootComponentProps = React.PropsWithChildren;

/**
 * RootComponent renders the common layout and provides an outlet for child routes.
 * It is intentionally decoupled from authentication context.
 * Authentication logic is handled by the AuthGuard component.
 */
export const RootComponent = ({ children }: RootComponentProps) => {
  return children ?? <Outlet />;
};
